import { twMerge } from 'tailwind-merge';
import { useInvestorCompany } from '@/hooks/useStore';
import List, { ListItem } from '@/components/List';
import InvestmentForm from '../InvestmentForm';
import { classes } from './utils';

export type InvestmentsListProps = {
  className?: string;
  companyId: number;
  investorId: number;
};

export default function InvestmentsList({
  className,
  companyId,
  investorId,
}: InvestmentsListProps) {
  const investorCompany = useInvestorCompany(companyId, investorId);

  if (!investorCompany) return null;

  return (
    <List className={twMerge(classes.list, className)}>
      {investorCompany.investments.map((investment) => (
        <ListItem
          key={investment.id}
          className={classes.listItem}
          disablePadding>
          <InvestmentForm
            companyId={companyId}
            investorId={investorId}
            investmentId={investment.id}
          />
        </ListItem>
      ))}
    </List>
  );
}
